import React from "react";

function UserIconName(props) {

    const {userEmail, diameter} = props;
    let height = diameter > 32 ? diameter : 32;
    let width = diameter > 32 ? diameter : 32;

    let first2Letters = "JD";

    if (userEmail) {
        first2Letters = userEmail.substring(0, 2).toUpperCase();
    }

    return (
        <div style={{
            background: "#1bc2c6",
            height: (height + "px"),
            width: (width + "px"),
            color: "white"
        }} className="rounded-circle">
            <div style={{
                fontWeight: "700",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "inherit"
            }}>
                {first2Letters}
            </div>

        </div>
    );
}

export default UserIconName;